import React, { Component } from "react"
import PropTypes from "prop-types"

import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

// import { LinkContainer } from "react-router-bootstrap"
import { 
  Grid, Col, PageHeader, Well, Glyphicon,
  Form, FormGroup, ControlLabel, FormControl, Button
} from "react-bootstrap"

import { Map, fromJS } from "immutable"
// import uuidv4 from "uuid"
// import numeral from "numeral"
import moment from "moment-timezone"
import "moment/locale/id"

import * as actionCreators from "../actions"

const listAddress = "/returns"
const recordType = "productReturns"

const newProductReturn = fromJS({
  uuid: "",
  orderNo: "",
  productName: "",
  dealerUuid: "",
  customerName: "",
  customerAddress: "",
  returnCost: 0,
  notes: ""
})

class ProductReturn extends Component {
  static propTypes = {
    productReturn: PropTypes.object,
    actions: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired
  }

  state = {
    edited: Map()
  }

  getValue = (name, isDate = false) => {
    let value = (this.state.edited && this.state.edited.get(name)) || (this.props.record && this.props.record.get(name)) || ""
    return (isDate ? (value ? moment(value).format() : moment().format()) : value)
  }

  handleChange = e => {
    const { name } = e.target
    let { value } = e.target

    if (name === "returnCost") {
      value = Number(value)
    }
    
    this.setState((prev, props) => ({ edited: prev.edited.set(name, value) }))
  }

  handleCancel = e => {
    if (this.state.edited.size === 0 || window.confirm("Are you sure you want to cancel?")) {
      this.props.history.push(listAddress)
    }
  }

  handleSubmit = e => {
    e.preventDefault()

    let record = this.state.edited
    let errors = ""
    
    // Check mandatory fields
    if (!this.getValue("orderNo")) {
      errors += (errors.length > 0 ? "\n" : "") + "No. Order is required!"
    }
    if (!this.getValue("productName")) {
      errors += (errors.length > 0 ? "\n" : "") + "Barang is required!"
    }
    if (!this.getValue("dealerUuid")) {
      errors += (errors.length > 0 ? "\n" : "") + "Dealer is required!"
    }
    if (!this.getValue("customerName")) {
      errors += (errors.length > 0 ? "\n" : "") + "Customer is required!"
    }

    if (this.props.uuid === "new") {          // new record      
      
      if (errors) {
        alert(errors)
        return
      } else {
        this.props.actions.createReturn(record)
      }

    } else {                                  // existing record
      
      if (errors) {
        alert(errors)
        return
      } else {
        this.props.actions.updateReturn(this.props.uuid, record)
      }
    }

    // Reset edited state
    this.setState({ edited: Map() })
    this.props.history.push(listAddress)
  }

  render() {
    return (
      <Grid>
        <PageHeader>Retur</PageHeader>

        <Form horizontal onSubmit={this.handleSubmit}>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>No. Order</Col>
            <Col sm={10}>
              <FormControl
                name="orderNo"
                placeholder="No. Order"
                value={this.getValue("orderNo")}
                onChange={this.handleChange} />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Barang</Col>
            <Col sm={10}>
              <FormControl
                name="productName"
                placeholder="Barang"
                value={this.getValue("productName")}
                onChange={this.handleChange} />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Dealer</Col>
            <Col sm={10}>
              <FormControl
                componentClass="select"
                name="dealerUuid"
                placeholder="Nama Dealer"
                value={this.getValue("dealerUuid")}
                onChange={this.handleChange}>
                  <option></option>
                  {this.props.dealers.valueSeq().map(d =>
                    <option key={d.get("uuid")} value={d.get("uuid")}>{d.get("dealerName")}</option>
                  )}
              </FormControl> 
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Nama Customer</Col>
            <Col sm={10}>
              <FormControl
                name="customerName"
                placeholder="Nama Customer"
                value={this.getValue("customerName")}
                onChange={this.handleChange} />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Alamat Customer</Col>
            <Col sm={10}>
              <FormControl componentClass="textarea"
                name="customerAddress"
                placeholder="Alamat Customer"
                value={this.getValue("customerAddress")}
                onChange={this.handleChange} />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Biaya</Col>
            <Col sm={10}>
              <FormControl className="text-right"
                type="number"
                name="returnCost"
                placeholder="Biaya"
                value={this.getValue("returnCost")}
                onChange={this.handleChange} />
            </Col>
          </FormGroup>
          <FormGroup>
          <Col componentClass={ControlLabel} sm={2}>Keterangan</Col>
          <Col sm={10}>
            <FormControl componentClass="textarea"
              name="notes"
              placeholder="Keterangan"
              value={this.getValue("notes")}
              onChange={this.handleChange} />
          </Col>
        </FormGroup>
      </Form>
          
        <Well bsSize="small">
          <Button bsSize="small" bsStyle="danger" onClick={this.handleCancel}>
            <Glyphicon glyph="remove" /> Cancel
          </Button>
          <Button className="pull-right" bsSize="small" bsStyle="primary" onClick={this.handleSubmit}>
            <Glyphicon glyph="save" /> Save
          </Button>
        </Well>
      </Grid>
    )
  }
} 

const mapStateToProps = (state, ownProps) => ({
  uuid: ownProps.match.params.id,
  record: ownProps.match.params.id === "new" ? newProductReturn : state.getIn([recordType, ownProps.match.params.id]),
  dealers: state.get("dealers") || Map()
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actionCreators, dispatch)
})

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductReturn))



// WEBPACK FOOTER //
// ./src/components/ProductReturn.js